import { render, staticRenderFns } from "./posters.vue?vue&type=template&id=4370a242&scoped=true&"
import script from "./posters.vue?vue&type=script&lang=js&"
export * from "./posters.vue?vue&type=script&lang=js&"
import style0 from "./posters.vue?vue&type=style&index=0&id=4370a242&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370a242",
  null
  
)

export default component.exports